import React from 'react';
import styles from '../../../contentfulPage.module.css';

/** @type import('@contentful/rich-text-react-renderer').NodeRenderer */
export default function Heading5(node, children) {
  return <h5 className={styles.header5}>{children}</h5>;
}
